import { ApiRespBacklogAgeBandsByBuckets } from '@/pages/OperationsInsights/types/BacklogMetricsResponse';

/**
 * Transform Chart Series - for Backlog Age Band Interval
 * use short function name due to `Maximum allowed is 150` lint error
 *
 * @param response
 * @param ageBandConfigNamesByDuration
 */
export const tfCsBLAgeBandByInterval = (response: ApiRespBacklogAgeBandsByBuckets, ageBandConfigNamesByDuration: string[]) => {
    const finalSortedAgeBands: string[] = [];
    ageBandConfigNamesByDuration.forEach( (i) => finalSortedAgeBands.push(i));
    response.metrics.forEach( (item) => {
        if (!finalSortedAgeBands.includes(item.ageBandName)) {
            finalSortedAgeBands.push(item.ageBandName);
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chartSeries: any[] = [];
    for (const ageBandName of finalSortedAgeBands) {
        const item = response.metrics.find( (i) => i.ageBandName === ageBandName);
        if (item) {
            chartSeries.push({
                type: 'area' as const,
                name: item.ageBandName,
                data: item.ageBandMetricsBuckets
                    .map((item) => [ new Date(item.bucket).valueOf(), item.openCount ])
            });
        }
    }
    return chartSeries;
};